import React from "react";
import Welcome from "react-welcome-page";
import "./pageLoad.css";

const PageLoad = () => {
  return (
    <Welcome
      loopDuration={2500}
      data={[
        {
          image: require("../../images/6ix.gif"),
          imageAnimation: "flip",
          backgroundColor: "#000",
          textAnimation: "flip",
          textColor: "#b71c1c",
          text: "Movies For Free!",
        },
      ]}
    />
  );
};

export default PageLoad;



// WEBPACK FOOTER //
// ./src/components/pageload/PageLoad.js